import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_DAMAGED_LOST_EXPENSE,
  RESET_DELAYED_LUGGAGE_EXPENSE,
  RESET_COMPENSATION,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    claimForPassportCreditCard: 'false',
    claimForTheftOfCash: 'false',
    claimForLuggageAndPersonalEffect: 'false',
    // howItHappened: '',

    // Are you claiming for Baggage Loss
    areYouClaimingForDamaged: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineForBaggage: '',
    scheduledDateOfDepartureForBaggage: '',
    scheduledDateOfReturnForBaggage: '',
    originationForBaggage: '',
    flightNumberOriginationForBaggage: '',
    airCarrierOriginationForBaggage: '',
    destinationForBaggage: '',
    flightNumberDestinationForBaggage: '',
    airCarrierDestinationForBaggage: '',
    dateOfLossForBaggageInfo: '',
    placeOfLossForBaggageInfo: '',
    nameForBaggageInfo: '',
    cityOrTownForBaggageInfo: '',
    countryForBaggageInfo: '',
    postalCodeForBaggageInfo: '',
    addressForBaggageInfo: '',
    contactForBaggageInfo: '',
    phoneForBaggageInfo: '',
    pleaseDescribeWhatOccurredForBaggageInfo: '',
    companyNameForBaggage: '',
    addressForBaggage: '',
    typeOfPolicyForBaggage: '',
    policyForBaggage: '',
    contactForBaggage: '',
    phoneForBaggage: '',
    additionalItems: [],
    // Are you claiming for lost items?
    areYouClaimingForALostItem: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineLostItem: '',
    scheduledDateOfDepartureLostItem: '',
    scheduledDateOfReturnLostItem: '',
    originationLostItem: '',
    flightNumberOriginationLostItem: '',
    airCarrierOriginationLostItem: '',
    destinationLostItem: '',
    flightNumberDestinationLostItem: '',
    airCarrierDestinationLostItem: '',
    dateOfLossLostItemInfo: '',
    placeOfLossLostItemInfo: '',
    addressLostItemInfo: '',
    contactLostItemInfo: '',
    phoneLostItemInfo: '',
    pleaseDescribeWhatOccurredLostItemInfo: '',
    companyNameLostItem: '',
    addressLostItem: '',
    typeOfPolicyLostItem: '',
    policyLostItem: '',
    contactLostItem: '',
    phoneLostItem: '',
    expenseItemsLostItem: [],
    // Are you claiming for lost items?
    areYouClaimingForValuables: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineValuables: '',
    scheduledDateOfDepartureValuables: '',
    scheduledDateOfReturnValuables: '',
    originationValuables: '',
    flightNumberOriginationValuables: '',
    airCarrierOriginationValuables: '',
    destinationValuables: '',
    flightNumberDestinationValuables: '',
    airCarrierDestinationValuables: '',
    dateOfLossValuablesInfo: '',
    placeOfLossValuablesInfo: '',
    addressValuablesInfo: '',
    contactValuablesInfo: '',
    phoneValuablesInfo: '',
    pleaseDescribeWhatOccurredValuablesInfo: '',
    companyNameValuables: '',
    addressValuables: '',
    typeOfPolicyValuables: '',
    policyValuables: '',
    contactValuables: '',
    phoneValuables: '',
    expenseItemsValuables: [],
    // Are you claiming for Baggage Delay
    areYouClaimingForBaggageDelay: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineForDelay: '',
    originationForDelay: '',
    flightNumberOriginationForDelay: '',
    airCarrierOriginationForDelay: '',
    destinationForDelay: '',
    flightNumberDestinationForDelay: '',
    airCarrierDestinationForDelay: '',
    dateLuggageDelay: '',
    timeLuggageDelay: null,
    dateLuggageReturn: '',
    timeLuggageReturn: null,
    haveYouMadeAClaimWithYourTravelProvider: 'false',
    companyNameForDelay: '',
    addressForDelay: '',
    cityOrTownForDelay: '',
    countryForDelay: '',
    postalCodeForDelay: '',
    typeOfPolicyForDelay: '',
    policyForDelay: '',
    contactForDelay: '',
    phoneForDelay: '',
    pleaseDescribeWhatOccurredForDelay: '',
    delayedLuggageExpenses: [],
    // Are you claiming for Baggage Delay (Per Day)?
    areYouClaimingForBaggageDelayPerDay: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineForPerDay: '',
    originationForPerDay: '',
    flightNumberOriginationForPerDay: '',
    airCarrierOriginationForPerDay: '',
    destinationForPerDay: '',
    flightNumberDestinationForPerDay: '',
    airCarrierDestinationForPerDay: '',
    dateLuggagePerDay: '',
    timeLuggagePerDay: null,
    dateLuggageReturnPerDay: '',
    timeLuggageReturnPerDay: null,
    haveYouMadeAClaimWithYourTravelProviderForPerDay: 'false',
    companyNameForPerDay: '',
    addressForPerDay: '',
    typeOfPolicyForPerDay: '',
    policyForPerDay: '',
    contactForPerDay: '',
    phoneForPerDay: '',
    pleaseDescribeWhatOccurredForPerDay: '',
    expenseItemsPerDay: [],
  },
  errors: [],
});

const initialDelayedLuggageExpenseState = {
  form: {
    claimForDelayLuggage: 'false',
    dateLuggageDelay: '',
    timeLuggageDelay: null,
    dateLuggageReturn: '',
    timeLuggageReturn: null,
    paidForDelay: 'false',
    madeClaimWithTravelProviderOrOther: 'false',
    listedOnThePolicy: 'false',
    delayedLuggageExpenses: [],
    dateCompensationWasReceived: '',
    compensationDescription: '',
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
  },
};

const initialDamagedLostStolenExpenseState = {
  form: {
    claimForDamagedLostOrStolenLuggageTravelDocumentOrCash: 'false',
    claimForPassportCreditCard: 'false',
    claimForTheftOfCash: 'false',
    claimForLuggageAndPersonalEffect: 'true',
    howItHappened: '',
    additionalItems: [],
  },
};

const emptyCompensationExpense = {
  form: {
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
    dateCompensationWasReceived: '',
    compensationDescription: '',
  },
};

function baggagePersonalEffectsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_DAMAGED_LOST_EXPENSE:
      return state
        .setIn(['form', 'additionalItems'], [])
        .mergeDeep(initialDamagedLostStolenExpenseState);
    case RESET_DELAYED_LUGGAGE_EXPENSE:
      return state
        .setIn(['form', 'delayedLuggageExpenses'], [])
        .mergeDeep(initialDelayedLuggageExpenseState);
    case RESET_COMPENSATION:
      return state.mergeDeep(emptyCompensationExpense);
    default:
      return state;
  }
}

export default baggagePersonalEffectsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.BaggagePersonalEffects/reducer.js